module.exports = __webpack_public_path__ + "img/addresses_mobile.551845c1.png";